import React, {
  Component,
  PropTypes,
} from 'react';
import { compose } from 'recompose';
import { routesByValue } from 'helpers/routesConstant';
import { withRouter } from 'react-router';
import HeaderContent from 'components/headers/HeaderContent';
import CustomTabs from 'components/Tabs/CustomTabs';
import muiThemeable from 'material-ui/styles/muiThemeable';
import Sticky from 'components/Sticky'

class Menus extends Component {
  render() {
    const { router, location: { pathname }, muiTheme: { palette } } = this.props;
    return (
      <div >
        <Sticky>
          <HeaderContent label={routesByValue.menus.label} />
          {(pathname === routesByValue.menus.value || pathname === routesByValue.manageMenuLocations.value) &&
          <div style={{ backgroundColor: palette.primary1Color }}>
            <CustomTabs
              defaultTabValue={pathname}
              onTouchTab={value => router.push(value)}
            >
              <CustomTabs.Tab
                tabValue={routesByValue.menus.value}
                tabLabel="Edit Menus"
                primary
                size="medium"
                borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
              />
              <CustomTabs.Tab
                tabValue={routesByValue.manageMenuLocations.value}
                tabLabel="Manage Locations"
                primary
                size="medium"
                borderStyle={{ borderBottom: `3px solid ${palette.accent1Color}` }}
              />
            </CustomTabs>
          </div>
          }
        </Sticky>
        {this.props.children}
      </div>
    );
  }
}

Menus.propTypes = {};
Menus.defaultProps = {};

export default compose(withRouter, muiThemeable())(Menus);




// WEBPACK FOOTER //
// ./src/pages/Menus/index.js